// The languages BOORO speaks. English comes first: it is the default and the
// source every other language is translated from.

export const PRODUCT_LOCALES = ["en", "de"] as const;

export type ProductLocale = (typeof PRODUCT_LOCALES)[number];

export const DEFAULT_LOCALE: ProductLocale = "en";

export function isProductLocale(value: unknown): value is ProductLocale {
  return PRODUCT_LOCALES.includes(value as ProductLocale);
}

/** The product language of a tag such as "de-AT", else English. */
export function productLocale(raw: string | null | undefined): ProductLocale {
  const primary = raw?.trim().toLowerCase().replace(/_/g, "-").split("-")[0];
  return isProductLocale(primary) ? primary : DEFAULT_LOCALE;
}

/**
 * The product language an Accept-Language header prefers most, or null when it
 * names none of them.
 */
export function localeFromAcceptLanguage(header: string | null | undefined): ProductLocale | null {
  if (!header) return null;
  const ranked = header
    .split(",")
    .map((part, index) => {
      const [tag = "", ...params] = part.trim().split(";");
      const q = params.map((param) => /^\s*q=([\d.]+)\s*$/.exec(param)?.[1]).find(Boolean);
      return { tag, weight: q === undefined ? 1 : Number(q), index };
    })
    .filter((entry) => entry.tag && entry.weight > 0)
    .sort((a, b) => b.weight - a.weight || a.index - b.index);
  for (const { tag } of ranked) {
    const primary = tag.toLowerCase().split("-")[0];
    if (isProductLocale(primary)) return primary;
  }
  return null;
}

export type { AuthEmail, AuthEmailKind } from "./emails.js";
export { authEmail } from "./emails.js";
export { localizeNotification } from "./notifications.js";
